import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { PeriodoPlanilla } from 'src/app/Models/planilla/periodo-planilla';
import { EstadoPeriodo } from 'src/app/Models/planilla/estado-periodo';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-periodo-pago',
  templateUrl: './periodo-pago.component.html',
  styleUrls: ['./periodo-pago.component.css']
})
export class PeriodoPagoComponent implements OnInit {

  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  public page: any;
  public total = 0;
  public items: PeriodoPlanilla[] = [];
  public nuevo: PeriodoPlanilla = new PeriodoPlanilla();
  public agregando = false;
  private _backup: { [id: number]: any } = {};

  public estados: EstadoPeriodo[] = [];
  public sucursales: any[] = [];

  public meses = [
    { id: 1, nombre: 'Enero' }, { id: 2, nombre: 'Febrero' },
    { id: 3, nombre: 'Marzo' }, { id: 4, nombre: 'Abril' },
    { id: 5, nombre: 'Mayo' }, { id: 6, nombre: 'Junio' },
    { id: 7, nombre: 'Julio' }, { id: 8, nombre: 'Agosto' },
    { id: 9, nombre: 'Septiembre' }, { id: 10, nombre: 'Octubre' },
    { id: 11, nombre: 'Noviembre' }, { id: 12, nombre: 'Diciembre' }
  ];

  constructor(private data: DataService, private title: Title) { }

  ngOnInit() {
    this.title.setTitle('Períodos de Planilla | Sistema');
    this.LoadSelects();
    this.GetData();
  }

  LoadSelects() {
    this.data.GetSimple(this.data.api.estado_periodo).subscribe(r => this.estados = r);
    this.data.GetSimple(this.data.api.sucursal).subscribe(r => this.sucursales = r);
  }

  GetData() {
    this.loading.show('Cargando...');
    this.items = [];
    this.data.GetSimple(this.data.api.periodo_planilla).subscribe(
      r => { this.loading.hide(); this.items = r; this.total = r.length; },
      e => { this.loading.hide(); this.info.error(e, () => { }); }
    );
  }

  getMesNombre(mes: number): string {
    const m = this.meses.find(x => x.id === mes);
    return m ? m.nombre : `${mes}`;
  }

  ShowNew() { this.nuevo = new PeriodoPlanilla(); this.agregando = true; }
  CancelNew() { this.agregando = false; this.nuevo = new PeriodoPlanilla(); }

  formNewValid(): boolean {
    console.log("Validando nuevo período:", this.nuevo);
    return !!(this.nuevo.anio && this.nuevo.mes && this.nuevo.fecha_inicio
      && this.nuevo.fecha_fin && this.nuevo.estado && this.nuevo.idsucursal);
  }

  SaveNew() {
    console.log(this.nuevo);
    this.loading.show('Registrando...');
    this.data.Post(this.data.api.periodo_planilla, this.nuevo).subscribe(
      r => { this.loading.hide(); this.agregando = false; this.nuevo = new PeriodoPlanilla(); this.GetData(); },
      e => { this.loading.hide(); this.info.error(e, () => { }); }
    );
  }

  StartEdit(item: PeriodoPlanilla) { this._backup[item.idperiodo] = { ...item }; item.editando = true; }
  CancelEdit(item: PeriodoPlanilla) { Object.assign(item, this._backup[item.idperiodo]); item.editando = false; }

  SaveEdit(item: PeriodoPlanilla) {
    this.loading.show('Actualizando...');
    this.data.Put(this.data.api.periodo_planilla, `${item.idperiodo}`, item).subscribe(
      r => { this.loading.hide(); item.editando = false; delete this._backup[item.idperiodo]; this.GetData(); },
      e => { this.loading.hide(); this.info.error(e, () => { }); }
    );
  }

  ShowDelete(item: PeriodoPlanilla) {
    this.info.show(`¿Deseas eliminar el período ${this.getMesNombre(item.mes)} ${item.anio}?`, 1, null,
      { cancelText: 'No, Cancelar', successText: 'Sí, Eliminar', isCancel: true },
      () => this.Delete(item), () => { this.info.hide(); }, 20);
  }

  Delete(item: PeriodoPlanilla) {
    this.loading.show('Eliminando...');
    this.data.Delete(this.data.api.periodo_planilla, `${item.idperiodo}`).subscribe(
      r => { this.loading.hide(); this.info.show(r.message, 2, null, null, () => { this.info.hide(); this.GetData(); }); },
      e => { this.loading.hide(); this.info.error(e, () => this.info.hide()); }
    );
  }
}
